// Re-exported so packages importing it from fe-reporting don't each need a fe-workflow-builder dependency.
export { useListWorkflows, useListWorkflowsSuspense } from '@omnea-app/fe-workflow-builder/useListWorkflows'
